export const environment = {
  production: false,
  authEnabled: false,
  deployUnderRmm: false,
  /** Route RMM via portal API proxy (same host as apiUrl). */
  rmmApiProxied: true,
  rmmApiUrl: 'api/v1/rmm',
  /** Log RMM HTTP + Server-Timing in browser console (dev). */
  rmmTiming: true,
  /** Direct RMM only: set rmmApiProxied false, rmmApiUrl to RMM base, and rmmApiToken. */
  rmmApiToken: '',
  appVersion: 'v8.2.7',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: false,
  workspacesMockFallback: false,
  apiUrl: '/api/v1',
  assetLookupBaseUrl: 'https://assets.ef-it.nl/lookup',
  appThemeName: 'Effective IT Portal',
};
